import { cn } from '@workspace/ui/lib/utils';
import type { InputHTMLAttributes } from 'react';

interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  disabled?: boolean;
  size: 'small' | 'medium';
}

export function Radio({ label, disabled, size, ...props }: RadioProps) {
  const id = `radio-${crypto.randomUUID()}`;

  const sizeMap = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
  };

  const innerSizeMap = {
    small: 'checked:after:w-[8px] checked:after:h-[8px]',
    medium: 'checked:after:w-[12px] checked:after:h-[12px]',
  };

  const fontSizeMap = {
    small: 'text-size-6',
    medium: 'text-size-5',
  };

  return (
    <div className='flex items-center gap-2 w-fit'>
      <label
        className={cn(
          `flex items-center gap-2 ${fontSizeMap[size]} font-regular tracking-[-0.1px]`,
        )}
      >
        <div className={cn(`relative ${sizeMap[size]} flex items-center justify-center`)}>
          <input
            id={id}
            type='radio'
            {...props}
            disabled={disabled}
            className={cn(
              `${sizeMap[size]}`,
              `appearance-none bg-action-gray-default rounded-full`,
              `checked:after:content-[''] checked:after:absolute checked:after:transform-[translate(50%,50%)] checked:after:rounded-full checked:after:bg-action-blue-default ${innerSizeMap[size]}`,
              props.className,
            )}
          />
        </div>
        {label && label}
      </label>
    </div>
  );
}
